import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, TextField, styled } from '@mui/material';
import './App.css';
import './devlink/global.css';
import { ButtonWithIcon, ClearButton } from './devlink';
import { PropertyList } from './components/property-list';
import { PropertyListItem } from './components/property-list-item';
import { EmailRequest } from './Home';

export interface SimpleDialogProps {
  open: boolean;
  onClose: (email: string | null) => void;
  data: EmailRequest | null;
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    backgroundImage: 'radial-gradient(circle farthest-corner at 50% 20%, hsla(0, 0.00%, 0.00%, 0.00), var(--neutral-colors--neutral-900) 32%), linear-gradient(to bottom, hsla(190.9090909090909, 47.83%, 4.51%, 0.24),hsla(190.9090909090909, 47.83%, 4.51%, 0.24))'
  },
}));

const options: Intl.DateTimeFormatOptions = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZoneName: 'short'
};

function EmailForm(props: SimpleDialogProps) {
  const { onClose, data, open } = props;

  if (!data) {
    return (<></>);
  }

  return (
    <BootstrapDialog
      open={open}
      onClose={() => onClose(null)}
      PaperProps={{
        component: 'form',
        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
          event.preventDefault();
          const formData = new FormData(event.currentTarget);
          const formJson = Object.fromEntries((formData as any).entries());
          const email = formJson.email;
          onClose(email);
        },
      }}
    >
      <DialogTitle>Confirm your meeting slot</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {data.description}
        </DialogContentText>
        <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="email"
            label="Email"
            type="email"
            fullWidth
            variant="outlined"
          />
          <Button fullWidth onClick={() => onClose(null)}>
            <ClearButton text="Decline" runtimeProps={{
              style: {width: "100%"},
              options: {
                href: "#",
              }
            }} />
          </Button>
          <Button fullWidth type="submit">
            <ButtonWithIcon text="Confirm Booking" buttonRuntimeProps={{
              style: {width: "100%"},
              options: {
                href: "#",
              }
            }} />
          </Button>
      </DialogContent>
    </BootstrapDialog>
  );
}

export default EmailForm;
